import { Id } from "@planzone/dto";

type Day = {
  date: string;
  workedDay: boolean;
  capacity: number;
  load: number;
};

type Week = {
  week: {
    from: string;
    to: string;
  };
  load: number;
  capacity: number;
  workedWeek: boolean;
};

type Month = {
  month: {
    from: string;
    to: string;
  };
  load: number;
  capacity: number;
  workedMonth: boolean;
};

type WorkLoad = {
  uuid: Id;
  resourceName: string;
  resourceRoleName: string;
  resourceTitle: string | null;
  resourceType: string;
  resourceTags: string[];
  totalOfEstimatedHours: number;
  totalOfAllocatedHours: number;
  totalOfSpentTime: number;
  totalOfRemainingTime: number;
  days: Day[];
  weeks: Week[];
  months: Month[];
};

type WorkLoadsCalendar = WorkLoad[];

const workLoadsCalendar: WorkLoadsCalendar = [];

export type { WorkLoad, WorkLoadsCalendar };

export { workLoadsCalendar };
